import {
  UPDATE_MARKUP_STATE,
  SET_MARKUP_EXTENSION,
  GET_MARKUPS,
  SET_VIEWERAPP_STATE,
} from "../constants/Constants";

const initialState = {
  markupState: "",
  markupExtension: null,
  markups: null,
  viewerState: null,
  title: null,
  reviewerId: null,
  markupFontSize: 1,
  markupStrokeWidth: 1,
  markupFontFamily: "Arial",
  markupColour: "#0D54FF",
};

export const markupStateReducer = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_MARKUP_STATE:
      return {
        ...state,
        markupState: action.payload,
      };
    case SET_MARKUP_EXTENSION:
      return {
        ...state,
        markupExtension: action.payload,
      };
    case GET_MARKUPS:
      return {
        ...state,
        markups: action.payload,
      };
    case SET_VIEWERAPP_STATE:
      return {
        ...state,
        viewerState: action.payload,
      };
    case "SET_TITLE":
      return {
        ...state,
        title: action.payload,
      };
    case "SET_REVIEWERID":
      return {
        ...state,
        reviewerId: action.payload,
      };
    case "markupFontSize":
      return {
        ...state,
        markupFontSize: action.payload,
      };
    case "markupStrokeWidth":
      return {
        ...state,
        markupStrokeWidth: action.payload,
      };
    case "markupFontFamily":
      return {
        ...state,
        [action.type]: action.payload,
      };
    case "markupColour":
      return {
        ...state,
        [action.type]: action.payload,
      };
    default:
      return state;
  }
};
